import { writable } from 'svelte/store';

export interface ConfirmConfig {
	message: string;
}

interface ConfirmDialogStore {
	(messageOrConfig: string | ConfirmConfig): Promise<boolean>;
	subscribe: (run: (value: { config: ConfirmConfig | null; resolve: ((value: boolean) => void) | null }) => void) => () => void;
	confirm: (messageOrConfig: string | ConfirmConfig) => Promise<boolean>;
	close: (accepted: boolean) => void;
}

function createConfirmDialog(): ConfirmDialogStore {
	const store = writable<{
		config: ConfirmConfig | null;
		resolve: ((value: boolean) => void) | null;
	}>({
		config: null,
		resolve: null
	});

	function confirm(messageOrConfig: string | ConfirmConfig): Promise<boolean> {
		const config = typeof messageOrConfig === 'string' ? { message: messageOrConfig } : messageOrConfig;
		return new Promise((resolve) => {
			store.update((prev) => ({ config, resolve }));
		});
	}

	function close(accepted: boolean) {
		store.update((prev) => {
			prev.resolve?.(accepted);
			return { config: null, resolve: null };
		});
	}

	const callable = confirm as any;
	callable.subscribe = store.subscribe;
	callable.confirm = confirm;
	callable.close = close;

	return callable;
}

export const confirmDialog = createConfirmDialog();
